export default function getMaskedAccountNumber(accNumber) {
    let maskedNumber = accNumber.replace('-', "").replace('#', "").replace(' ', '').trim();
    if (maskedNumber && maskedNumber.length > 4) {
        maskedNumber = ('' + maskedNumber).slice(0, -4)
            .replace(/./g, '*')
            + ('' + maskedNumber).slice(-4);
    }
    return `${maskedNumber}`;
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/MaskedAccountNumber.js